import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=83978012&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=ts&"
export * from "./Orders.vue?vue&type=script&lang=ts&"
import style0 from "./Orders.vue?vue&type=style&index=0&id=83978012&prod&scoped=true&lang=css&"
import style1 from "./Orders.vue?vue&type=style&index=1&id=83978012&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83978012",
  null
  
)

export default component.exports